import Cookies from 'js-cookie';

export const PDF_DOWNLOAD_COOLDOWN_MS = 15 * 60 * 1000;
export const PDF_DOWNLOAD_COOLDOWN_EVENT = 'pdf-download-cooldown-change';
// Cooldown only applies to downloads whose range is longer than this.
export const PDF_DOWNLOAD_COOLDOWN_MIN_RANGE_SECONDS = 5 * 24 * 60 * 60;

// Stored in both localStorage and a cookie so the cooldown survives logout,
// closing the browser, and the forced `localStorage.clear()` on 401/403.
const STORAGE_KEY = 'pdf-download-cooldown-until';

function parseTimestamp(value?: string | null) {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}

function readLocalStorage() {
  try {
    return parseTimestamp(localStorage.getItem(STORAGE_KEY));
  } catch {
    return 0;
  }
}

// startAt/endAt are unix timestamps in seconds, matching the report filter.
export function isPdfDownloadCooldownRange(startAt: number, endAt: number) {
  return endAt - startAt >= PDF_DOWNLOAD_COOLDOWN_MIN_RANGE_SECONDS;
}

export function getPdfDownloadCooldownUntil() {
  return Math.max(readLocalStorage(), parseTimestamp(Cookies.get(STORAGE_KEY)));
}

export function getPdfDownloadCooldownRemaining() {
  return Math.max(0, getPdfDownloadCooldownUntil() - Date.now());
}

function notifyChange() {
  window.dispatchEvent(new Event(PDF_DOWNLOAD_COOLDOWN_EVENT));
}

export function startPdfDownloadCooldown() {
  const until = Date.now() + PDF_DOWNLOAD_COOLDOWN_MS;
  try {
    localStorage.setItem(STORAGE_KEY, String(until));
  } catch {
    // Cookie below is the fallback.
  }
  Cookies.set(STORAGE_KEY, String(until), {
    expires: new Date(until),
    sameSite: 'strict',
  });
  notifyChange();
}

export function clearPdfDownloadCooldown() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  Cookies.remove(STORAGE_KEY);
  notifyChange();
}

export function formatPdfDownloadCooldown(remainingMs: number) {
  const totalSeconds = Math.ceil(remainingMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
